import {CdkMenuTrigger} from "@angular/cdk/menu"
import {ChangeDetectionStrategy, Component, input, output} from "@angular/core"
import {AssetActionsMenuComponent, AssetCellChipComponent, AssetGridCellComponent, AssetMenuAction} from "@common/components/asset-grid"
import {DataObjectThumbnailComponent} from "@common/components/data-object-thumbnail/data-object-thumbnail.component"
import {ThumbnailLayout} from "@common/models/enums/thumbnail-layout"

export type PinnedImageInput = {
    id: string
    downloadUrl: string
    originalFileName: string
    mediaType?: string | null
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-pinned-asset-cell",
    templateUrl: "./pinned-asset-cell.component.html",
    styleUrls: ["./pinned-asset-cell.component.scss"],
    imports: [AssetActionsMenuComponent, AssetCellChipComponent, AssetGridCellComponent, CdkMenuTrigger, DataObjectThumbnailComponent],
})
export class PinnedAssetCellComponent {
    readonly $pinnedImage = input<PinnedImageInput | null | undefined>(null, {alias: "pinnedImage"})
    readonly $canEdit = input<boolean>(false, {alias: "canEdit"})
    readonly $canDownload = input<boolean>(false, {alias: "canDownload"})
    readonly unpin = output<void>()
    readonly preview = output<void>()

    readonly actions: AssetMenuAction[] = [{id: "unpin", label: "Unpin from gallery", icon: "fa-trash-can", variant: "destructive"}]

    readonly ThumbnailLayout = ThumbnailLayout

    onAction(actionId: string) {
        if (actionId === "unpin") {
            this.unpin.emit()
        }
    }
}
